export default "__VITE_ASSET__COpWFeIy__"